import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';

@Injectable({ providedIn: 'root' })
export class CriticalRequestService {
    constructor(private dataService: DataService) { }

    public get(page: number, order: string, orderT: string, filter: string) {
        let url = 'request/critical?filter.page=' + page;

        if (order)
            url += '&filter.orderByField=' + order;

        if (orderT)
            url += '&filter.orderBy=' + orderT;

        if (filter)
            url += '&filter.entity.critical=' + filter
                + '&filter.entity.description=' + filter
                + '&filter.entity.releaseDate=' + filter

        return this.dataService.get<Result<any>>(url);
    }

    public delete(cod: number) {
        return this.dataService.delete<Result<string>>('request/critical/' + cod.toString());
    }
}
